import { Cases } from '~/models/cases';
import { Image } from '~/models/image';

export const casesService = {
	fetch: async (): Promise<Cases.Model> => {
		const params = {
			fields: ['*', 'photo.directus_files_id.*', 'form.*'],
		};

		try {
			const response = await $fetch<
				Omit<Cases.Model, 'photo'> & { photo: { directus_files_id: Image.Model }[] }
			>(Cases.api, {
				method: 'POST',
				body: { params },
			});

			/** Resolve images */
			const images = response.photo.reduce((acc, { directus_files_id }) => {
				acc.push(directus_files_id);
				return acc;
			}, [] as Image.Model[]);

			return { ...response, photo: images };
		} catch (error) {
			console.error('Failed to fetch Cases:', error);

			return { ...Cases.modelState, photo: [] };
		}
	},
};
